var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 284",
    style: {
      enableBackground: "new 0 0 1080 284"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFF31D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.3,183.3V284H5V5.4h64.3v23.4C85.2,9.6,106.1,0.4,129,0.4c50.5,0,88.5,37.6,88.5,105.7 c0,68.5-38,106.1-88.5,106.1C106.5,212.2,86,203.4,69.3,183.3z M152,106.1c0-30.1-19.2-48.9-44.3-48.9c-13.8,0-30.5,7.5-38.4,18.4 V137c7.9,10.4,24.6,18.4,38.4,18.4C132.8,155.4,152,136.6,152,106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387.2,36.4L387.2,36.4c0,17.1,13.8,30.9,30.9,30.9h2.5c17.1,0,30.9-13.8,30.9-30.9v0 c0-17.1-13.8-30.9-30.9-30.9h-2.5C401,5.4,387.2,19.3,387.2,36.4z M387.2,90.8v44.9c-7.5,9.6-20.1,19.6-38.4,19.6 c-20.9,0-33.4-8.4-33.4-32.6v-32H251v58.3c0,37.2,20.5,63.1,66.4,63.1c33.8,0,57.2-15.1,69.7-29.2v24.2h64.3V90.8H387.2z M251,36.4 L251,36.4c0,17.1,13.8,30.9,30.9,30.9h2.5c17.1,0,30.9-13.8,30.9-30.9v0c0-17.1-13.8-30.9-30.9-30.9h-2.5 C264.8,5.4,251,19.3,251,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M481.1,181.3l26.7-44.3c15,13.4,47.2,26.7,71,26.7c19.2,0,27.2-6.3,27.2-15.5c0-26.3-117.4-0.4-117.4-81.4 c0-35.5,30.5-66.4,86.5-66.4c33.8,0,62.6,10.9,84.4,26.7l-24.6,42.6c-12.1-11.7-35.1-22.1-59.3-22.1c-15,0-25.5,6.3-25.5,14.6 c0,23.4,117.4,0.4,117.4,83.1c0,38.4-33.8,66.8-91.9,66.8C539.6,212.2,502.4,200.1,481.1,181.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M700.4,36.4L700.4,36.4c0,17.1,13.8,30.9,30.9,30.9h2.5c17.1,0,30.9-13.8,30.9-30.9v0 c0-17.1-13.8-30.9-30.9-30.9h-2.5C714.2,5.4,700.4,19.3,700.4,36.4z M836.5,36.4L836.5,36.4c0,17.1,13.8,30.9,30.9,30.9h2.5 c17.1,0,30.9-13.8,30.9-30.9v0c0-17.1-13.8-30.9-30.9-30.9h-2.5C850.4,5.4,836.5,19.3,836.5,36.4z M836.5,90.8v44.9 c-7.5,9.6-20.1,19.6-38.4,19.6c-20.9,0-33.4-8.4-33.4-32.6v-32h-64.3v58.3c0,37.2,20.5,63.1,66.4,63.1c33.8,0,57.2-15.1,69.7-29.2 v24.2h64.3V90.8H836.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M947.6,207.2V5.4h64.3v24.6C1025.3,13.8,1050.8,0,1075,0v61.8c-3.8-0.8-9.2-1.7-15.9-1.7 c-16.7,0-38.8,7.1-47.2,18.4v128.6H947.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.190279637bd09458fbcecfe8d0d12b50.svg";
export { ForwardRef as ReactComponent };